import store from "@/store";

const routes = [{
    path: "/accounting/packing-list-history/:id",
    name: "acctpackinglisthistory",
    component: () => import('@/views/main/modules/Accounting/PackingListHistory/PackingListHistoryGroupComponent.vue'),
    beforeEnter: (to, from, next) => {
        store.dispatch('checkAccessUser', to.params.id).then((response) => {
            if (response == 'fail') {
                next('/no-access')
            } else {
                next()
            }
        }).catch(() => {

        })
    },
    meta: {
        requiresAuth: true,
        title: 'Delivery Receipt History',
    }
}]

export default routes;
